import {
    likersSummaryOnePersonYouText,
    likersSummaryOneOtherPersonText,
    likersSummaryTwoPersonYouAndOneOtherText,
    likersSummaryTwoPersonOtherText,
    likersSummaryThreePersonYouAndTwoOtherText,
    likersSummaryOneOtherText,
    likersSummaryThreePersonOtherText,
    likersSummaryYouAndMoreThanMaxLikersText,
    likersSummaryFourPersonYouAndMoreOtherText,
    likersSummaryNOthersText,
    likersSummaryOtherMoreThanMaxLikersText,
    likersSummaryFourPersonOthersText,
} from './getMessageLikersDisplayString.locstring.json';
import loc, { format } from 'owa-localize';
import Message from 'owa-service/lib/contract/Message';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

const MaxLikesPerMessage = 100;

export function getMessageLikersDisplayString(message: Message): string | null {
    try {
        // We have seen some cases where LikeCount and Likers mismatch
        // Protecting on the Try block and return null, since this string is only added as
        // aria label of the button
        if (message.LikeCount && message.Likers) {
            const userEmailAddress = getUserConfiguration().SessionSettings.UserEmailAddress;
            const isLikedByUser = message.Likers
                ? message.Likers.some(email => email.EmailAddress === userEmailAddress)
                : false;

            switch (message.LikeCount) {
                case 1:
                    if (isLikedByUser) {
                        return loc(likersSummaryOnePersonYouText);
                    }

                    return format(loc(likersSummaryOneOtherPersonText), message.Likers[0].Name);
                case 2:
                    if (isLikedByUser) {
                        return format(
                            loc(likersSummaryTwoPersonYouAndOneOtherText),
                            message.Likers.filter(
                                email => email.EmailAddress !== userEmailAddress
                            )[0].Name
                        );
                    }

                    return format(
                        loc(likersSummaryTwoPersonOtherText),
                        message.Likers[0].Name,
                        message.Likers[1].Name
                    );
                case 3:
                    if (isLikedByUser) {
                        return format(
                            loc(likersSummaryThreePersonYouAndTwoOtherText),
                            message.Likers[0].Name,
                            loc(likersSummaryOneOtherText)
                        );
                    }

                    return format(
                        loc(likersSummaryThreePersonOtherText),
                        message.Likers[0].Name,
                        message.Likers[1].Name,
                        loc(likersSummaryOneOtherText)
                    );
                default:
                    if (isLikedByUser) {
                        if (message.LikeCount >= MaxLikesPerMessage) {
                            return format(
                                loc(likersSummaryYouAndMoreThanMaxLikersText),
                                MaxLikesPerMessage - 1
                            );
                        }

                        return format(
                            loc(likersSummaryFourPersonYouAndMoreOtherText),
                            message.Likers[0].Name,
                            format(loc(likersSummaryNOthersText), message.LikeCount - 2)
                        );
                    } else {
                        if (message.LikeCount >= MaxLikesPerMessage) {
                            return format(
                                loc(likersSummaryOtherMoreThanMaxLikersText),
                                MaxLikesPerMessage - 1
                            );
                        }

                        return format(
                            loc(likersSummaryFourPersonOthersText),
                            message.Likers[0].Name,
                            message.Likers[1].Name,
                            format(loc(likersSummaryNOthersText), message.LikeCount - 2)
                        );
                    }
            }
        }
    } catch {
        return null;
    }

    return null;
}

export function getLikeCountDisplayString(message: Message): string | null {
    if (message.LikeCount) {
        return message.LikeCount < MaxLikesPerMessage
            ? message.LikeCount.toString()
            : MaxLikesPerMessage - 1 + '+';
    }

    return null;
}
